import { styled } from '@mui/material/styles'
import React from 'react'
import { APIEntity } from 'services/api/entities'
import { useKGetList } from 'services/hooks/useKGetList'
import { distinctById } from 'services/utils'
import { VoidFunction, WithId } from 'types/common'
import LocalizedSelectInput from './LocalizedFields/LocalizedSelectInput'

const PREFIX = 'FilterSelectInput'

const classes = {
  selectStyle: `${PREFIX}-selectStyle`,
}

const Root = styled(LocalizedSelectInput)(() => ({
  [`& .${classes.selectStyle}`]: { width: '250px', marginBottom: '-17px' },
}))

export type FilterSelectInputProps<T extends WithId> = {
  entity: APIEntity
  searchFn: (v: any) => T[]
  source: string
  optionText: keyof T
  label: string
  onChange: VoidFunction
}

/**
 * This is an input that fetches a list and takes unique elements given from a search function to put into a select input.
 * @param listResource the current resource of the list to fetch
 * @param searchFn the function that takes a list element and returns the element with witch to filter
 * @param source the source of the filter
 * @param optionText the name to display in the select input taken from the object of the filter
 */
export const FilterSelectInput = <T extends WithId>({
  entity,
  searchFn,
  source,
  optionText,
  onChange,
  label,
}: FilterSelectInputProps<T>) => {
  const resource = useKGetList(entity)

  // the list to which the filter applies
  const items = resource.flatMap(searchFn)
  const choices = distinctById(items)

  return (
    <Root
      className={classes.selectStyle}
      source={source}
      label={label}
      choices={choices.map((e: T) => ({
        id: e.id,
        name: e[optionText],
      }))}
      onChange={onChange}
    />
  )
}
